import {Dropdown} from "web-components";
import React from "react";
import _ from "lodash";
import {useIntl} from "react-intl";
import {createFragmentContainer, graphql} from "react-relay";
import PropTypes from "prop-types";
import {SkillLine} from "./SkillLine";

const SkillDropdown = ({name, skills, skillCategories, selectedItems, onSelect, onRemove, emphasizeEmptyState, disabled, usePortal, width, selectedGroupName}) => {
	const {formatMessage} = useIntl();
	const noCategory = formatMessage({id: 'settings_skills.no_category'});
	skillCategories = [...skillCategories, {id: undefined, name: noCategory}];
	const skillsByCategoryId = _.groupBy(skills, skill => skill.category?.id);

	const getSearchString = skill =>
		[skill.name, skill.category?.name].map(string => string?.toLowerCase()).join(' ');

	return (
		<Dropdown
			isClearable
			isNested
			isMultiSelect
			usePortal={usePortal}
			selectedGroupName={selectedGroupName}
			name={name}
			selectedItems={selectedItems}
			onSelect={onSelect}
			onRemove={onRemove}
			cy={'skill-category-skills'}
			emphasizeEmptyState={emphasizeEmptyState}
			disabled={disabled}
			width={width}
		>
			{skillCategories.map(skillCategory => (
				<Dropdown.Group name={skillCategory.name} key={`skill-category-${skillCategory.id}`}>
					{skillsByCategoryId[skillCategory.id]?.map(skill => (
						<SkillLine key={skill.id} value={skill.id} searchString={getSearchString(skill)}
								   name={skill.name} category={skill.category}/>
					))}
				</Dropdown.Group>
			))}
		</Dropdown>
	);
};

SkillDropdown.propTypes = {
	name: PropTypes.string,
	skills: PropTypes.arrayOf(
		PropTypes.shape({
			node: PropTypes.shape({
				id: PropTypes.string.isRequired,
				name: PropTypes.string.isRequired,
				category: PropTypes.shape({
					id: PropTypes.string.isRequired,
					name: PropTypes.string.isRequired,
				}),
			}),
		})
	).isRequired,
	skillCategories: PropTypes.arrayOf(
		PropTypes.shape({
			node: PropTypes.shape({
				id: PropTypes.string.isRequired,
				name: PropTypes.string.isRequired,
			}),
		})
	).isRequired,
	selectedItems: PropTypes.array.isRequired,
	onSelect: PropTypes.func.isRequired,
	onRemove: PropTypes.func.isRequired,
	emphasizeEmptyState: PropTypes.bool,
	disabled: PropTypes.bool,
	usePortal: PropTypes.bool,
	width: PropTypes.number,
	selectedGroupName: PropTypes.string,
};

export default createFragmentContainer(SkillDropdown, {
	skillCategories: graphql`
        fragment SkillDropdown_skillCategories on SkillCategory @relay(plural: true) {
            id
            name
        }
	`,
	skills: graphql`
        fragment SkillDropdown_skills on Skill @relay(plural: true) {
            id
            name
            category {
                id
                name
            }
        }
	`,
});